import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CtaButton } from './ui/CtaButton';
import { Gift, Clock, CheckCircle2, ShieldCheck, Zap, FileText, AlertTriangle, ArrowRight, Lock } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    id: 1,
    title: 'BONO #1 — KIT "CERO FRICCIÓN"',
    subtitle: 'Configura tus 4 cuentas en 30 minutos',
    value: '$47 USD',
    image: 'https://cdn.magicpatterns.com/uploads/4syHH1GikufoyyhnLvaSb6/Bono_1.png',
    description: 'La mayoría compra el manual… y se atasca en el setup. No porque sea difícil. Sino porque no saben por dónde empezar. Este kit te quita esa fricción.',
    benefit: 'Te da nombres exactos, reglas copy/paste y un checklist paso a paso para que en 30 minutos dejes tus cuentas separadas, con funciones claras y listas para trabajar.',
    includes: ['Guía "Setup 30-min" (PDF ejecutable)', '3 rutas según tu situación (2, 3 o 4 cuentas)', 'Nombres recomendados (copy/paste directo a tu banco)', 'Plantilla de reglas rápidas (entrada/salida/movimiento)', 'Los 7 errores típicos del setup (y cómo evitarlos)', 'Checklist final imprimible'],
    forWho: 'Si te da flojera "pensar mucho" y solo quieres dejarlo listo hoy, este bono te ahorra horas de parálisis.'
  }, {
    id: 2,
    title: 'BONO #2 — GUÍA "ANTI-MEZCLA"',
    subtitle: 'Reglas de transferencias y pagos automáticos',
    value: '$47 USD',
    image: 'https://cdn.magicpatterns.com/uploads/9ScnV6eAsvuUmvFq6MMLUS/bono_2.png',
    description: 'El sistema funciona cuando tú estás motivado. Pero se rompe cuando estás cansado, ocupado o ansioso. Por eso este bono automatiza el orden.',
    benefit: 'Te enseña qué transferir, cuándo, con qué frecuencia y bajo qué reglas para que tu dinero se separe sin que tengas que recordarlo.',
    includes: ['Guía "Automatizaciones Anti-Mezcla" (PDF)', '3 modelos de frecuencia (según tu tipo de ingreso)', '12 reglas "si-entonces" listas para copiar', 'Mapa de pagos automáticos (qué cuenta paga qué)', 'Plantilla de calendario mensual/quincenal', 'Checklist de configuración (1 tarde, listo)'],
    forWho: 'Si eres indisciplinado, si tus ingresos son variables, o si simplemente odias "estar encima" de tu dinero todo el tiempo.'
  }, {
    id: 3,
    title: 'BONO #3 — WORKBOOK "ANSIEDAD → ACCIÓN"',
    subtitle: '10 minutos para volver al control',
    value: '$47 USD',
    image: 'https://cdn.magicpatterns.com/uploads/sYTRNwTF1ofk4DcEngUhDX/bono_3.png',
    description: 'Aquí está el punto donde la gente pierde dinero: Cuando sienten urgencia, mueven plata para calmarse. Y después se arrepienten.',
    benefit: 'Este workbook te da un protocolo de 10 minutos para frenar el impulso, bajar la activación y tomar la decisión correcta (no la que te calma 5 minutos).',
    includes: ['Workbook rellenable "Ansiedad → Acción" (PDF)', 'Reset de 90 segundos (respiración + postura + enfoque)', 'Plantilla "De emoción a número" (para ver qué te asusta realmente)', 'Decisión en 3 preguntas (función / tiempo / movimiento mínimo)', 'Lista de acciones permitidas (y prohibidas) bajo ansiedad', 'Tracker de impulsos 7 días (para descubrir tu patrón)', 'Tarjeta móvil "Pausa antes de mover" (versión de bolsillo)'],
    forWho: 'Si las noticias te activan, si tiendes a "invertir para recuperar", o si compras para calmarte… esto te salva.'
  }];
  return <section className="w-full px-4 md:px-6 py-12 md:py-24 bg-brand-bg relative overflow-hidden" data-id="element-22">
      {/* Background accent */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-brand-gold/5 via-transparent to-transparent pointer-events-none" data-id="element-23"></div>

      <div className="max-w-4xl mx-auto space-y-20 relative z-10" data-id="element-24">
        {/* Header */}
        <FadeIn data-id="element-25">
          <div className="text-center space-y-4 mb-16" data-id="element-26">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-gold/10 border border-brand-gold/20 text-brand-gold font-bold text-sm tracking-wide uppercase" data-id="element-27">
              Regalos exclusivos
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-28">
              TUS 3 BONOS GRATIS
            </h2>
            <p className="text-xl md:text-2xl text-brand-muted font-serif italic" data-id="element-29">
              (VALOR REAL:{' '}
              <span className="text-brand-gold line-through decoration-brand-gold/50" data-id="element-30">
                $47 USD
              </span>
              )
            </p>
          </div>
        </FadeIn>

        {/* Bonuses Cards */}
        <div className="space-y-12" data-id="element-31">
          {bonuses.map((bono, index) => <FadeIn key={bono.id} delay={index * 0.1} data-id="element-32">
              <div className="bg-brand-card border border-brand-gold/10 rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl hover:shadow-brand-gold/5 transition-all duration-300 group" data-id="element-33">
                <div className="grid md:grid-cols-12 gap-0" data-id="element-34">
                  {/* Image Side */}
                  <div className="md:col-span-5 bg-brand-bg/50 relative overflow-hidden min-h-[300px] md:min-h-full flex items-center justify-center" data-id="element-35">
                    <div className="absolute inset-0 bg-brand-gold/5 group-hover:bg-brand-gold/10 transition-colors duration-500" data-id="element-36"></div>
                    <img src={bono.image} alt={bono.title} className={`relative z-10 w-full h-full transition-transform duration-500 group-hover:scale-105 ${index !== 0 ? 'object-cover object-top md:object-contain md:scale-150 md:origin-top' : 'object-cover'}`} data-id="element-37" />
                    <div className="absolute top-4 left-4 bg-brand-gold text-brand-bg font-bold text-xs px-3 py-1 rounded shadow-lg z-20" data-id="element-38">
                      HOY: GRATIS
                    </div>
                  </div>

                  {/* Content Side */}
                  <div className="md:col-span-7 p-6 md:p-8 flex flex-col justify-center" data-id="element-39">
                    <div className="mb-4" data-id="element-40">
                      <h3 className="text-xl md:text-2xl font-bold text-white mb-1" data-id="element-41">
                        {bono.title}
                      </h3>
                      <p className="text-brand-gold font-medium text-lg" data-id="element-42">
                        {bono.subtitle}
                      </p>
                    </div>

                    <div className="space-y-4 mb-6" data-id="element-43">
                      <p className="text-brand-text/90 leading-relaxed" data-id="element-44">
                        {bono.description}
                      </p>
                      <p className="text-brand-text/90 leading-relaxed font-medium" data-id="element-45">
                        {bono.benefit}
                      </p>
                    </div>

                    <div className="bg-brand-bg/50 rounded-xl p-5 border border-brand-gold/10 mb-6" data-id="element-46">
                      <h4 className="text-white font-bold text-sm uppercase tracking-wide mb-3 flex items-center gap-2" data-id="element-47">
                        <FileText className="w-4 h-4 text-brand-gold" data-id="element-48" />
                        Lo que incluye:
                      </h4>
                      <ul className="space-y-2" data-id="element-49">
                        {bono.includes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-brand-muted" data-id="element-50">
                            <CheckCircle2 className="w-4 h-4 text-brand-gold/70 mt-0.5 shrink-0" data-id="element-51" />
                            <span data-id="element-52">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="flex items-start gap-3 text-sm italic text-brand-muted bg-brand-gold/5 p-4 rounded-lg border-l-2 border-brand-gold" data-id="element-53">
                      <Zap className="w-4 h-4 text-brand-gold mt-0.5 shrink-0" data-id="element-54" />
                      <p data-id="element-55">
                        <strong className="text-brand-gold not-italic" data-id="element-56">
                          Para quién:
                        </strong>{' '}
                        {bono.forWho}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* Summary Section */}
        <FadeIn data-id="element-57">
          <div className="bg-gradient-to-br from-brand-card to-brand-bg border border-brand-gold rounded-2xl p-8 md:p-12 relative overflow-hidden mt-12" data-id="element-58">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-59"></div>

            <div className="text-center mb-10" data-id="element-60">
              <div className="inline-flex items-center justify-center p-3 bg-brand-gold/10 rounded-full mb-4" data-id="element-61">
                <Lock className="w-6 h-6 text-brand-gold" data-id="element-62" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-63">
                RESUMEN DE TU OFERTA COMPLETA HOY
              </h3>
            </div>

            <div className="bg-brand-bg/80 backdrop-blur-sm rounded-xl p-6 md:p-8 border border-brand-gold/20 max-w-2xl mx-auto mb-10 shadow-lg" data-id="element-64">
              <ul className="space-y-4" data-id="element-65">
                <li className="flex items-center gap-3 text-lg md:text-xl text-white font-bold" data-id="element-66">
                  <CheckCircle2 className="w-6 h-6 text-brand-gold shrink-0" data-id="element-67" />
                  <span data-id="element-68">
                    Manual del Dinero{' '}
                    <span className="text-brand-muted font-normal text-base" data-id="element-69">
                      (ebook principal)
                    </span>
                  </span>
                </li>
                <li className="flex items-center gap-3 text-lg md:text-xl text-white" data-id="element-70">
                  <CheckCircle2 className="w-6 h-6 text-brand-gold shrink-0" data-id="element-71" />
                  <span data-id="element-72">
                    BONO #1: Kit "Cero Fricción"{' '}
                    <span className="text-brand-gold font-bold" data-id="element-73">(GRATIS)</span>
                  </span>
                </li>
                <li className="flex items-center gap-3 text-lg md:text-xl text-white" data-id="element-74">
                  <CheckCircle2 className="w-6 h-6 text-brand-gold shrink-0" data-id="element-75" />
                  <span data-id="element-76">
                    BONO #2: Guía "Anti-Mezcla"{' '}
                    <span className="text-brand-gold font-bold" data-id="element-77">(GRATIS)</span>
                  </span>
                </li>
                <li className="flex items-center gap-3 text-lg md:text-xl text-white" data-id="element-78">
                  <CheckCircle2 className="w-6 h-6 text-brand-gold shrink-0" data-id="element-79" />
                  <span data-id="element-80">
                    BONO #3: Workbook "Ansiedad → Acción"{' '}
                    <span className="text-brand-gold font-bold" data-id="element-81">(GRATIS)</span>
                  </span>
                </li>
              </ul>
              <div className="mt-6 pt-6 border-t border-brand-gold/20 text-center" data-id="element-82">
                <p className="text-brand-muted mb-1" data-id="element-83">
                  Valor total si los compraras por separado:{' '}
                  <span className="line-through" data-id="element-84">$47 USD</span>
                </p>
                <p className="text-brand-gold font-bold text-lg" data-id="element-85">
                  Hoy los recibes gratis al ordenar el Manual.
                </p>
              </div>
            </div>

            {/* Why Bonuses */}
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 mb-12 max-w-3xl mx-auto" data-id="element-86">
              <div data-id="element-87">
                <h4 className="text-white font-bold text-lg mb-4 flex items-center gap-2" data-id="element-88">
                  <Zap className="w-5 h-5 text-brand-gold" data-id="element-89" />
                  POR QUÉ TE DAMOS ESTOS BONOS
                </h4>
                <p className="text-brand-muted text-sm leading-relaxed mb-4" data-id="element-90">
                  Porque sabemos que la mayoría de la gente no falla por falta
                  de conocimiento. Falla por:
                </p>
                <ul className="space-y-2 text-sm text-brand-text/90" data-id="element-91">
                  <li className="flex items-start gap-2" data-id="element-92">
                    <span className="text-brand-gold" data-id="element-93">•</span>
                    <span data-id="element-94">
                      No saber por dónde empezar (Bono #1 te lo resuelve)
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-95">
                    <span className="text-brand-gold" data-id="element-96">•</span>
                    <span data-id="element-97">
                      Volver a mezclar cuando están ocupados (Bono #2 te lo
                      automatiza)
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-98">
                    <span className="text-brand-gold" data-id="element-99">•</span>
                    <span data-id="element-100">
                      Mover dinero por ansiedad (Bono #3 te da el freno)
                    </span>
                  </li>
                </ul>
              </div>

              <div data-id="element-101">
                <h4 className="text-white font-bold text-lg mb-4 flex items-center gap-2" data-id="element-102">
                  <Clock className="w-5 h-5 text-brand-gold" data-id="element-103" />
                  ESTA OFERTA NO DURA
                </h4>
                <p className="text-brand-muted text-sm leading-relaxed mb-4" data-id="element-104">
                  Los bonos están incluidos solo durante el lanzamiento. Después
                  de esta ventana, vuelven a venderse por separado.
                </p>
                <div className="bg-brand-red/10 border border-brand-red/20 rounded-lg p-3 flex items-start gap-3" data-id="element-105">
                  <AlertTriangle className="w-5 h-5 text-brand-red shrink-0" data-id="element-106" />
                  <p className="text-xs text-brand-red font-medium" data-id="element-107">
                    Si estás leyendo esto ahora, todavía estás a tiempo.
                  </p>
                </div>
              </div>
            </div>

            {/* Decision */}
            <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-108">
              <h3 className="text-2xl font-bold text-white mb-6" data-id="element-109">
                TU DECISIÓN ES SIMPLE
              </h3>
              <div className="grid sm:grid-cols-2 gap-4 text-left" data-id="element-110">
                <div className="bg-brand-bg/30 p-4 rounded-lg border border-brand-bg hover:border-brand-muted/30 transition-colors" data-id="element-111">
                  <p className="font-bold text-brand-muted mb-2" data-id="element-112">Opción 1</p>
                  <p className="text-sm text-brand-text/80" data-id="element-113">
                    Seguir improvisando cada mes, sintiendo que "algo falta"
                    pero sin estructura real para ejecutar.
                  </p>
                </div>
                <div className="bg-brand-gold/10 p-4 rounded-lg border border-brand-gold/30 hover:border-brand-gold/50 transition-colors" data-id="element-114">
                  <p className="font-bold text-brand-gold mb-2" data-id="element-115">Opción 2</p>
                  <p className="text-sm text-white" data-id="element-116">
                    Ordenar hoy, recibir el Manual + los 3 bonos, y en 7 días
                    tener un sistema que funciona incluso cuando tú no estás al
                    100%.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="flex flex-col items-center gap-4" data-id="element-117">
              <CtaButton onClick={() => document.getElementById('final-cta')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-118">
                Comprar Ahora + Bonos Gratis
              </CtaButton>
              <div className="flex items-center gap-2 text-xs text-brand-muted" data-id="element-119">
                <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-120" />
                <span data-id="element-121">Acceso inmediato digital · Sin envíos · Sin esperas</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}